<template>
<div class="login-wrapper" v-show="visible">
  <div class="back" @click="showLoginView"><i class="fas fa-long-arrow-alt-left"></i></div>
  <div class="pw-header">인증번호 입력</div>
  <div class="blank20"></div>
  <div :class="$style['body-wrapper']" v-loading="loading">
    <div class="body">
      <div class="cert-detail">
        인증 번호를 전송했습니다.
        <div class="blank7"></div>
        <span class="info">{{address}}</span>
      </div>
      <div class="blank10"></div>
      <div class="cert">
        <el-input style="width: 295px;" ref="authKeyField" size="small" placeholder="인증번호 입력" v-model="authKey" @keyup.enter.native="checkAuthKey" @change="invalidMsg = null">
          <el-button slot="append" @click="generateAuthKey()">재전송</el-button>
        </el-input>
      </div>
      <div class="remaining"> {{authKeyTimerMsg}} </div>
      <!-- message -->
      <div class="message-wrapper" style="margin-left:30px; margin-top:5px;">
        <span v-show="invalidMsg !== null" class="error">
          <i class="fas fa-exclamation-circle" style="margin-right:4px;"></i>
          <span>{{invalidMsg}}</span>
        </span>
      </div>
      <div class="blank20"></div>
      <!--/el-form-item-->
      <el-button @click="checkAuthKey"> 인증 완료 </el-button>
    </div>
  </div>
</div>
</template>

<script>
import loginApi from '@/api/login';

export default {
  name: 'WAuthView',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    address: {
      type: String,
    },
  },
  data() {
    return {
      /**
       * 인증 키 입력 정보
       * @type {String}
       */
      authKey: '',
      /**
       * 인증 번호 유효 시간 (seconds)
       * @type {Number}
       */
      authKeyTime: 300,
      /**
       * 인증 번호 유효 시간 타이머 Task
       * @type {[type]}
       */
      authKeyTimerTask: 'authKeyTimerTask',
      invalidMsg: null,
      loading: false,
    };
  },
  computed: {
    /**
     * 인증 번호 유효 시간 타이머 메시지
     * @author Ju
     * @return {[type]} [description]
     */
    authKeyTimerMsg() {
      const time = this.authKeyTime;

      if (time === 0) {
        return '인증 번호가 만료되었습니다. 인증 번호를 다시 발급해주십시오.';
      }
      // 정수로부터 남은 시, 분, 초 단위 계산
      let min = Math.floor(time / 60);
      let sec = time - (min * 60);

      // hh:mm:ss 형태를 유지하기 위해 한자리 수일 때 0 추가
      if (min < 10) min = `0${min}`;
      if (sec < 10) sec = `0${sec}`;
      return `남은 시간: ${min}분 ${sec}초`;
    },
  },
  watch: {
    /**
     * 뷰가 활성화 될 경우 뷰의 초기화 작업을 해준다.
     * @author Ju
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    visible(to) {
      if (to) {
        this.$refs.authKeyField.focus();
        this.authAddress = '';
        this.authKey = null;
        this.invalidMsg = null;
        this.loading = false;
        this.resetAuthKeyTimer();
        this.startAuthKeyTimer();
      } else {
        this.removeAuthKeyTimerTask();
      }
    },
  },
  beforeDestroy() {
    this.removeAuthKeyTimerTask();
  },
  methods: {
    /**
     * 입력한 인증 번호가 발급된 인증 번호와 일치하는지 확인한다.
     * @author Ju
     * @return {[type]} [description]
     */
    checkAuthKey() {
      this.loading = true;
      loginApi
        .checkAuthKey(this.authKey)
        .then((response) => {
          this.loading = false;
          const result = response.data;
          if (result.success) {
            this.resetAuthKeyTimer();
            this.invalidMsg = null;
            this.$store.dispatch('setLoginInfo', result.data);
            this.$router.push({
              path: '/',
            });
          } else {
            this.invalidMsg = '유효한 인증 번호가 아닙니다.';
          }
        })
        .catch(() => {
          this.loading = false;
          this.invalidMsg = '통신 오류입니다. 다시 시도해주십시오.';
        });
    },
    /**
     * 인증 번호를 재발급한다.
     * @author Ju
     * @return {[type]} [description]
     */
    generateAuthKey() {
      loginApi.generateAuthKey().then((response) => {
        if (response.data.success === true) {
          this.tmpAuthKey = response.data.data;
          this.authKey = null;
          this.invalidAuth = false;
          this.resetAuthKeyTimer();
          this.startAuthKeyTimer();
        }
      });
    },
    /**
     * 인증 번호 타이머를 실행한다.
     * @author Ju
     * @return {[type]} [description]
     */
    startAuthKeyTimer() {
      this.$taskManager.createTask(this.authKeyTimerTask, 1, this.decreaseTime);
      this.$taskManager.startTask(this.authKeyTimerTask);
    },
    /**
     * 인증 번호 타이머 시간을 1초씩 감소시킨다.
     * @author Ju
     * @return {[type]} [description]
     */
    decreaseTime() {
      if (this.authKeyTime >= 1) {
        this.authKeyTime -= 1;
      } else {
        this.$taskManager.removeTask(this.authKeyTimerTask);
        this.invalidAuth = false;
      }
    },
    /**
     * 인증 번호 타이머를 초기화 한다.
     * @author Ju
     */
    resetAuthKeyTimer() {
      this.authKeyTime = 180;
      this.removeAuthKeyTimerTask();
    },
    /**
     * 인증 번호 타이머 Task를 제거한다.
     * @author Ju
     * @return {[type]} [description]
     */
    removeAuthKeyTimerTask() {
      if (this.$taskManager.existTask(this.authKeyTimerTask)) {
        this.$taskManager.removeTask(this.authKeyTimerTask);
      }
    },
    /**
     * 로그인 화면으로 전환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    showLoginView() {
      this.$emit('login-view-show');
    },
  },
};
</script>

<style module>
.body-wrapper {
  width: 100%;
  height: calc(100% - 110px);
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/AuthView.vue